/**
 * @param {object} params
 * @param {name} params.label
 */
function getSlugText(label) {
  return encodeURIComponent(
    label
      .toLowerCase()
      .normalize("NFD") // normalize characters
      .replace(/[\u0300-\u036f]/g, "") // remove accents
      .replace(/[^a-zA-Z0-9 ]/g, "") // remove non-alphanumeric characters
      .replace(/(\s+)/g, "-"), // replace spaces with -
  );
}

export default getSlugText;
